import { color as foundationColor } from "../foundation";

export const buildShadow = (color, size) => {
  const presets = {
    sm: [
      `0 0.5px 2px 0 ${color}1F`,   // 12%
      `0 0.5px 1px 0 ${color}29`,   // 16%
      `0 1px 4px 2px ${color}33`,   // 20%
    ],
    lg: [
      `0 4px 18px 3px ${color}1F`,  // 12%
      `0 7px 10px 1px ${color}24`,  // 14%
      `0 5px 6px -3px ${color}33`,  // 20%
    ],
  };

  return (presets[size] || []).join(', ');
};


export const effects = {
  border: {
    sm: '1px',
    md: '2px',
    lg: '4px',
  },
  radius: {
    sm: '4px',
    md: '8px',
    full: '9999px',
  },
  shadow: {
    sm: buildShadow(foundationColor.neutral.black, 'sm'),  // default shadow for cards, panels, etc.
    lg: buildShadow(foundationColor.neutral.black, 'lg'),  // elevated shadow for modals, popovers, etc.
  }
}

export default effects;